import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Wrapper from '../Wrapper';
import InstructorGradebookContainer from './InstructorGradebookContainer/InstructorGradebookContainer';

const InstructorGradebookContainerWrapper = (props) => {
  return (
    <Wrapper profilerId="InstructorGradebook" {...props}>
      <InstructorGradebookContainer {...props} />
    </Wrapper>
  );
};

export default InstructorGradebookContainerWrapper;
